import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../config/api';

const Announcements = ({ phoneNumber }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/system-settings/welcome-announcement`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch announcement');
        }

        const data = await response.json();
        console.log("************************************")
        console.log(data)
        console.log("**************************************")
        if (data.template) {
          // Replace the phone number placeholder with the actual phone number
          const formattedAnnouncement = data.template.replace(/\[Insert AI Phone Number Here\]/g, phoneNumber || 'Loading...');
          setAnnouncement(formattedAnnouncement);
        } else {
          console.error('No template found in response:', data);
          setAnnouncement(`Your AI assistant is ready at: ${phoneNumber}`);
        }
      } catch (error) {
        console.error('Error fetching welcome announcement:', error);
        // Fallback to a simple announcement if template fetch fails
        setAnnouncement(`**Welcome to Nexopta!!** We’re excited to have you on board. You’re just a few steps away from launching your first AI Assistant and unlocking the power of your AI Workforce. Let’s get started!}`);
      }
    };

      fetchAnnouncement();
    
  }, [phoneNumber]);

  if (!isVisible || !announcement) return null;

  return (
    <div className="dash-announce">
      <button
        type="button"
        className="dash-announce-close"
        aria-label="Dismiss announcement"
        onClick={() => setIsVisible(false)}
      >
        ×
      </button>
      <div
        className="dash-announce-body"
        dangerouslySetInnerHTML={{ __html: announcement.split('*').map((part, i) =>
          i % 2 === 0 ? part : `<strong>${part}</strong>`
        ).join('') }}
      />
    </div>
  );
};

export default Announcements;
